<template lang="pug">
  div
    loading(:active.sync="isLoading", :can-cancel="false", :is-full-page="true")
    b-container
      b-row
        b-col#panel-bienvenida(cols=12)
          h1 
            span Bienvenido 
            small GESTION :: SUPERIOR
          h4 
            span Usted ha iniciado sesión como: 
            b-badge(variant="success") Cuenta Global
          h5
            span La última vez que iniciaste sesión fue: 
            b-badge(variant="primary") {{ new Date() | dateFormat('YYYY-MM-DD HH:mm') }}
          h5
            span La última vez que tu sesión tuvo activadad fue: 
            b-badge(variant="primary") {{ new Date() | dateFormat('YYYY-MM-DD HH:mm') }}
      b-row.mt-3
        b-col(cols=6)
          b-card
            template(v-slot:header) Seleccione un estado
            template(v-slot:footer) &nbsp;
            div.map
              l-map(:zoom="zoom", :center="center", :options="mapOptions")
                l-tile-layer(:url="layerURL")
        b-col(cols=6)
          b-card
            template(v-slot:header) Filtro
            template(v-slot:footer) &nbsp;
            // States section
            form
              label(for="state") Estados
              b-form-select(name="state", v-model="selectedState", :options="states", @change="onChangeState")
                template(v-slot:first)
                  b-form-select-option(value="null", disabled) -- Seleccione un estado --
            //div.pull-right
              b-button.mt-2(@click="() => { $refs['resEstado'].show() }") Ver resumen
            // Regions section   
            form.mt-2
              label(for="region") Regiones
              b-form-select(name="region", v-model="selectedRegion", :options="regions", @change="onChangeRegion")
                template(v-slot:first)
                  b-form-select-option(value="null", disabled) -- Seleccione una región --
            //div.pull-right
              b-button.mt-2(@click="() => { $refs['resRegiones'].show() }") Ver resumen
            // Cities section
            form.mt-2
              label(for="city") Municipios
              b-form-select(name="city", v-model="selectedCity", :options="cities", @change="onChangeCity")
                template(v-slot:first)
                  b-form-select-option(value="null", disabled) -- Seleccione un municipio --
            //div.pull-right
              b-button.mt-2(@click="() => { $refs['resMunicipios'].show() }") Ver resumen
      b-row.mt-3
        b-col(cols=12)
          b-card
            template(v-slot:header) Promedios por disciplina
            template(v-slot:footer) &nbsp;
            b-row(v-if="state_stats && state_stats.length > 0")
              b-col.mb-4(cols=6, v-for="avs in state_stats", :key="avs.block")
                h5 {{ avs.block }}
                b-row(v-for="subject in avs.subjects", :key="subject.name")
                  b-col(cols=5) {{ subject.name }}
                  b-col(cols=7)
                    b-progress(animated, :max=10, :striped="true", :value="subject.average", :variant="subject.average > 7 ? 'success' : 'warning'", show-progress)
            b-row.justify-content-md-center(v-else)
              h4.empty-data No se han encontrado resultados o no se ha seleccionado un estado

      b-row.mt-3
        b-col(cols=6)
          b-card
            template(v-slot:header) Lista de Escuelas
            template(v-slot:footer) &nbsp;
            b-row(v-if="schools.length !== 0")
              b-col(cols="12" md="auto", v-for="(school, index) in schools" :key="index")
                b-button(variant="link", @click="chooseSchool(school.id)") 
                  span {{ school.name }} &nbsp;
                  small {{ school.shift }}
            b-row.justify-content-md-center(v-else)
              h4.empty-data No se encontraron escuelas
        b-col(cols=6)
          b-card
            template(v-slot:header) Detalle escuelas
            template(v-slot:footer) &nbsp;
            div(v-if="selectedSchool")
              b-row
                b-col(cols=12)
                  span {{ selectedSchool.name }} &nbsp;
                  small {{ selectedSchool.manager }}
              
              b-row.mt-3
                b-col(cols=3)
                  strong Turno:&nbsp;
                  span {{ selectedSchool.shift }}
                b-col(cols=3)
                  strong &Aacute;mbito:&nbsp;
                  span {{ selectedSchool.ambit }}
                b-col(cols=3)
                  strong Servicio:&nbsp;
                  span {{ selectedSchool.service }}
                b-col(cols=3)
                  strong Control:&nbsp;
                  span {{ selectedSchool.control }}
              
              hr
              div.mt-3(v-for="subject in selectedSchool.subject" :key="subject.name")
                b-row
                  b-col.pull-right(cols=3)
                    strong(style="word-wrap: normal;") {{ subject.name }}
                  b-col(cols=9)
                    b-progress(animated, :max=10, :striped="true", :value="Math.ceil(subject.average)", :variant="subject.average > 7 ? 'success' : 'warning'", show-progress)
                b-row.justify-content-md-center.mt-2
                  b-col(cols=2, v-for="block in subject.blocks", :key="block.name")
                    b-progress(animated, :max=10, :striped="true", :value="Math.ceil(block.average)", :variant="block.average > 7 ? 'success' : 'warning'", show-progress)
                hr
              
              b-row.mt-3
                b-col.pull-right(cols="4")
                  strong {{ selectedSchool.average_global.name }}
                b-col(cols="8")
                  b-progress(animated, :max=10, :striped="true", :value="Math.ceil(selectedSchool.average_global.average)", :variant="selectedSchool.average_global.average > 7 ? 'success' : 'warning'", show-progress)
            div(v-else)
              b-row.justify-content-md-center
                h4.empty-data Selecciona una escuela
      
      // STATE STATS
      b-modal(ref="resEstado", hide-footer, title="Resumen del Estado", size="lg")
        b-container
          div(v-for="subject in state_resume_data.subjects")
            b-row.mb-2
              b-col.pull-right(cols=3)
                strong {{ subject.name }}
              b-col(cols=9)
                b-progress(animated, :max=10, :striped="true", :value="Math.ceil(subject.average)", :variant="subject.average > 7 ? 'success' : 'warning'", show-progress)
            b-row.justify-content-md-center.mb-4
              b-col(cols=2, v-for="block in subject.blocks", :key="block.name")
                b-progress(animated, :max=10, :striped="true", :value="Math.ceil(block.average)", :variant="subject.average > 7 ? 'success' : 'warning'", show-progress)
          b-row
            b-col.pull-right(cols="4")
              strong {{ state_resume_data.average_global.name }}
            b-col(cols="8")
              b-progress(animated, :max=10, :striped="true", :value="Math.ceil(state_resume_data.average_global.average)", :variant="state_resume_data.average_global.average > 7 ? 'success' : 'warning'", show-progress)
          hr
          b-row.mb-3
            h5.text-justify Resumen de normalidad mínima en consejos técnicos escolares
          b-row
            b-col(cols="6", v-for="(info, index) in consejos_tecnicos_estado", :key="index")
              h5.text-justify {{ info.label }}
              doughnut-chart(style="height: 280px;", :labels="info.data.map(el => el.label)", :data="info.data.map(el => el.value)")
      
      // REGION STATS
      b-modal(ref="resRegiones", hide-footer, title="Resumen de regiones", size="lg")
        b-container
          div(v-for="subject in region_resume_data.subjects")
            b-row.mb-2
              b-col.pull-right(cols=3)
                strong {{ subject.name }}
              b-col(cols=9)
                b-progress(animated, :max=10, :striped="true", :value="Math.ceil(subject.average)", :variant="subject.average > 7 ? 'success' : 'warning'", show-progress)
            b-row.justify-content-md-center.mb-4
              b-col(cols=2, v-for="block in subject.blocks", :key="block.name")
                b-progress(animated, :max=10, :striped="true", :value="Math.ceil(block.average)", :variant="subject.average > 7 ? 'success' : 'warning'", show-progress)
          b-row
            b-col.pull-right(cols="4")
              strong {{ region_resume_data.average_global.name }}
            b-col(cols="8")
              b-progress(animated, :max=10, :striped="true", :value="Math.ceil(region_resume_data.average_global.average)", :variant="region_resume_data.average_global.average > 7 ? 'success' : 'warning'", show-progress)
          hr
          b-row.mb-3
            h5.text-justify Resumen de normalidad mínima en consejos técnicos escolares
          b-row.mb-3
            b-col(cols="12")
              radar-chart(style="height: 280px;", :labels="consejos_tecnicos_global_region.map(el => el.label)", :data="consejos_tecnicos_global_region.map(el => el.value)")
          b-row
            b-col(cols="6", v-for="(info, index) in consejos_tecnicos_region", :key="index")
              h5.text-justify 
                strong {{ info.head }}:&nbsp;
                span {{ info.label }}
              doughnut-chart(style="height: 280px;", :labels="info.data.map(el => el.label)", :data="info.data.map(el => el.value)")
      
      // CITY STATS
      b-modal(ref="resMunicipios", hide-footer, title="Resumen de municipios", size="lg")
        b-container
          div(v-for="subject in city_resume_data.subjects")
            b-row.mb-2
              b-col.pull-right(cols=3)
                strong {{ subject.name }}
              b-col(cols=9)
                b-progress(animated, :max=10, :striped="true", :value="Math.ceil(subject.average)", :variant="subject.average > 7 ? 'success' : 'warning'", show-progress)
            b-row.justify-content-md-center.mb-4
              b-col(cols=2, v-for="block in subject.blocks", :key="block.name")
                b-progress(animated, :max=10, :striped="true", :value="Math.ceil(block.average)", :variant="subject.average > 7 ? 'success' : 'warning'", show-progress)
          b-row
            b-col.pull-right(cols="4")
              strong {{ city_resume_data.average_global.name }}
            b-col(cols="8")
              b-progress(animated, :max=10, :striped="true", :value="Math.ceil(city_resume_data.average_global.average)", :variant="city_resume_data.average_global.average > 7 ? 'success' : 'warning'", show-progress)
          hr
          b-row.mb-3
            h5.text-justify Resumen de normalidad mínima en consejos técnicos escolares
          b-row.mb-3
            b-col(cols="12")
              radar-chart(style="height: 280px;", :labels="consejos_tecnicos_global_city.map(el => el.label)", :data="consejos_tecnicos_global_city.map(el => el.value)")
          b-row
            b-col(cols="6", v-for="(info,index) in consejos_tecnicos_ciudad", :key="index")
              h5.text-justify 
                strong {{ info.head }}:&nbsp;
                span {{ info.label }}
              doughnut-chart(style="height: 280px;", :labels="info.data.map(el => el.label)", :data="info.data.map(el => el.value)")

</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import Loading from 'vue-loading-overlay'

import 'leaflet/dist/leaflet.css'
import 'vue-loading-overlay/dist/vue-loading.css'

import DoughnutChart    from '@/components/DoughnutChart'
import RadarChart       from '@/components/RadarChart'
import LocationServices from '@/services/locations.service'
import SchoolServices   from '@/services/school.service'
import { AlertMixin }   from '@/mixins/AlertMixin'

export default {
  name: 'Home',

  components: {
    DoughnutChart,
    RadarChart,
    Loading,
    'l-map': LMap,
    'l-tile-layer': LTileLayer,
    'l-marker': LMarker
  },

  mixins: [ AlertMixin ],

  data() {
    return {
      // START LOADER SETUP DATA
      isLoading: false,
      // END LOADER SETUP DATA

      // START MAP SETUP DATA
      zoom: 4,
      center: latLng(22.836946, -460.195313),
      layerURL: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', // DEFAULT LAYER
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 0.5, // ZOOM BUTTONS JUMP
        zoomControl: false, // DISABLE CORNER ZOOM BUTTONS
        doubleClickZoom: false, // DISABLE ZOOM WHEN DOUBLE CLICKING ON MAP
        scrollWheelZoom: false, // DISABLE ZOOM CHANGE WHEN MOUSE SCROLLING
        dragging: false // DISABLE CLICK DRAG MOVE ON MAP
      },
      // END MAP SETUP DATA

      selectedState: null, // STATE CHOOSED
      selectedRegion: null, // REGION CHOOSED
      selectedCity: null, // CITY CHOOSED
      selectedSchool: null, // SCHOOL CHOOSED

      states: [],
      regions: [],
      cities: [],
      schools: [],

      ///////////////////////////////////
      /// RESUMEN DE ESTADO
      state_resume_data: {
        subjects: [
          { 
            name: 'Matemáticas',
            average: 7.9167,
            blocks: [
              { name: 'Bloque 1', average: 9.0000 },
              { name: 'Bloque 2', average: 8.0833 },
              { name: 'Bloque 3', average: 6.0000 },
              { name: 'Bloque 4', average: 7.5000 },
              { name: 'Bloque 5', average: 9.0000 }  
            ]
          },
          {
            name: 'Español',
            average: 6.9500,
            blocks: [
              { name: 'Bloque 1', average: 7.2500 },
              { name: 'Bloque 2', average: 7.0833 },
              { name: 'Bloque 3', average: 6.6666 },
              { name: 'Bloque 4', average: 7.2500 },
              { name: 'Bloque 5', average: 6.5000 }  
            ]
          },
          {
            name: 'Ciencias',
            average: 7.3667,
            blocks: [
              { name: 'Bloque 1', average: 7.3333 },
              { name: 'Bloque 2', average: 7.1667 },
              { name: 'Bloque 3', average: 7.2500 },
              { name: 'Bloque 4', average: 7.4167 },
              { name: 'Bloque 5', average: 7.6667 }  
            ]
          }
        ],
        average_global: { name: "Avance Programático", average: 7.5335 }
      },
      consejos_tecnicos_estado: [
        {
          label: 'Nuestra escuela brindó el servicio educativo durante todos los días del bimestre.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          label: 'Todos los grupos tuvieron maestro durante todos los días del bimestre',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        },
        {
          label: 'Todos los maestros iniciaron puntualmente sus actividades.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          label: 'Todos los alumnos asistieron puntualmente a todas su clases.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          label: 'Todos los materiales están a disposición de cada estudiante y se usan sistemáticamente.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          label: 'Todo el tiempo escolar se ocupa fundamentalmente en actividades de aprendizaje.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          label: 'Las actividades en las aulan logran que todos los alumnos participen activamente en el trabajo en clase.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          label: 'Todos los alumnos consolidan su dominio de la lectura, la escritura y las matemáticas de acuerdo con su grado educativo.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }
      ],
      ///////////////////////////////////
      /// RESUMEN DE REGIONES
      region_resume_data: {
        subjects: [
          { 
            name: 'Matemáticas',
            average: 7.9167,
            blocks: [
              { name: 'Bloque 1', average: 9.0000 },
              { name: 'Bloque 2', average: 8.0833 },
              { name: 'Bloque 3', average: 6.0000 },
              { name: 'Bloque 4', average: 7.5000 },
              { name: 'Bloque 5', average: 9.0000 }  
            ]
          },
          {
            name: 'Español',
            average: 6.9500,
            blocks: [
              { name: 'Bloque 1', average: 7.2500 },
              { name: 'Bloque 2', average: 7.0833 },
              { name: 'Bloque 3', average: 6.6666 },
              { name: 'Bloque 4', average: 7.2500 },
              { name: 'Bloque 5', average: 6.5000 }  
            ]
          },
          {
            name: 'Ciencias',
            average: 7.3667,
            blocks: [
              { name: 'Bloque 1', average: 7.3333 },
              { name: 'Bloque 2', average: 7.1667 },
              { name: 'Bloque 3', average: 7.2500 },
              { name: 'Bloque 4', average: 7.4167 },
              { name: 'Bloque 5', average: 7.6667 }  
            ]
          }
        ],
        average_global: { name: "Avance Programático", average: 7.5335 }
      },
      consejos_tecnicos_global_region: [
        { label: 'Categoria 1', value: 80 },
        { label: 'Categoria 2', value: 73 },
        { label: 'Categoria 3', value: 62 },
        { label: 'Categoria 4', value: 85 },
        { label: 'Categoria 5', value: 90 },
        { label: 'Categoria 6', value: 83 },
        { label: 'Categoria 7', value: 95 },
        { label: 'Categoria 8', value: 50 },
      ],
      consejos_tecnicos_region: [
        {
          head: "Categoria 1",
          label: 'Nuestra escuela brindó el servicio educativo durante todos los días del bimestre.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          head: "Categoria 2",
          label: 'Todos los grupos tuvieron maestro durante todos los días del bimestre',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        },
        {
          head: "Categoria 3",
          label: 'Todos los maestros iniciaron puntualmente sus actividades.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          head: "Categoria 4",
          label: 'Todos los alumnos asistieron puntualmente a todas su clases.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          head: "Categoria 5",
          label: 'Todos los materiales están a disposición de cada estudiante y se usan sistemáticamente.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          head: "Categoria 6",
          label: 'Todo el tiempo escolar se ocupa fundamentalmente en actividades de aprendizaje.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          head: "Categoria 7",
          label: 'Las actividades en las aulan logran que todos los alumnos participen activamente en el trabajo en clase.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          head: "Categoria 8",
          label: 'Todos los alumnos consolidan su dominio de la lectura, la escritura y las matemáticas de acuerdo con su grado educativo.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }
      ],
      /////////////////////////////////////
      //// RESUME DE MUNICIPIOS
      city_resume_data: {
        subjects: [
          { 
            name: 'Matemáticas',
            average: 7.9167,
            blocks: [
              { name: 'Bloque 1', average: 9.0000 },
              { name: 'Bloque 2', average: 8.0833 },
              { name: 'Bloque 3', average: 6.0000 },
              { name: 'Bloque 4', average: 7.5000 },
              { name: 'Bloque 5', average: 9.0000 }  
            ]
          },
          {
            name: 'Español',
            average: 6.9500,
            blocks: [
              { name: 'Bloque 1', average: 7.2500 },
              { name: 'Bloque 2', average: 7.0833 },
              { name: 'Bloque 3', average: 6.6666 },
              { name: 'Bloque 4', average: 7.2500 },
              { name: 'Bloque 5', average: 6.5000 }  
            ]
          },
          {
            name: 'Ciencias',
            average: 7.3667,
            blocks: [
              { name: 'Bloque 1', average: 7.3333 },
              { name: 'Bloque 2', average: 7.1667 },
              { name: 'Bloque 3', average: 7.2500 },
              { name: 'Bloque 4', average: 7.4167 },
              { name: 'Bloque 5', average: 7.6667 }  
            ]
          }
        ],
        average_global: { name: "Avance Programático", average: 7.5335 }
      },
      consejos_tecnicos_global_city: [
        { label: 'Categoria 1', value: 80 },
        { label: 'Categoria 2', value: 73 },
        { label: 'Categoria 3', value: 62 },
        { label: 'Categoria 4', value: 85 },
        { label: 'Categoria 5', value: 90 },
        { label: 'Categoria 6', value: 83 },
        { label: 'Categoria 7', value: 95 },
        { label: 'Categoria 8', value: 50 },
      ],
      consejos_tecnicos_ciudad: [
        {
          head: "Categoria 1",
          label: 'Nuestra escuela brindó el servicio educativo durante todos los días del bimestre.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          head: "Categoria 2",
          label: 'Todos los grupos tuvieron maestro durante todos los días del bimestre',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        },
        {
          head: "Categoria 3",
          label: 'Todos los maestros iniciaron puntualmente sus actividades.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          head: "Categoria 4",
          label: 'Todos los alumnos asistieron puntualmente a todas su clases.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          head: "Categoria 5",
          label: 'Todos los materiales están a disposición de cada estudiante y se usan sistemáticamente.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          head: "Categoria 6",
          label: 'Todo el tiempo escolar se ocupa fundamentalmente en actividades de aprendizaje.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          head: "Categoria 7",
          label: 'Las actividades en las aulan logran que todos los alumnos participen activamente en el trabajo en clase.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }, 
        {
          head: "Categoria 8",
          label: 'Todos los alumnos consolidan su dominio de la lectura, la escritura y las matemáticas de acuerdo con su grado educativo.',
          data: [
            { label: 'Siempre',      value: 25.00 },
            { label: 'Casi siempre', value: 43.75 },
            { label: 'Casi nunca',   value: 18.75 },
            { label: 'Nunca',        value: 12.50 }
          ]
        }
      ]
    }
  },

  methods: {
    async onChangeState(value) {
      this.state_stats = null // RESET STATE STATS DATA
      this.regions = []  // RESET REGION DATA COLLECTION
      this.selectedRegion = null // RESET SELECTED REGION
      this.cities = []  // RESET CITIES DATA COLLECTION
      this.selectedCity = null // RESET SELECTED CITY
      this.schools = [] // RESET SCHOOL DATA COLLECTION
      this.selectedSchool = null // RESET SELECTED SCHOOL DATA
      
      if(value == null) return // IF NO ITEM SELECTED DO NOTHING 
      
      this.isLoading = true // ENABLE LOADING SCREEN
      
      // FIND SELECTED STATE FULL DATA
      let state = this.states.find((state) => state.value == value);
      
      // SET UP MAP CENTER AND ZOOM IF COORDS AVAILABLE
      if(!state.coords) {
        this.center = latLng(22.836946, -460.195313)
        this.zoom = 4
      } else {
        this.center = latLng(state.coords.lat, state.coords.lng)
        this.zoom = state.coords.z
      }

      // POPULATE REGION COLLECTION
      try {
        this.state_stats = await LocationServices.getStateStats(value);

        const regions = await LocationServices.getRegionsInState(value)
        this.regions = regions.map(region => { return { value: region.id, text: region.nombre } })  // MAP ARRAY TO SELECT MODULE
        if(this.regions.length === 0)
          this.warningMessage("", "No hay regiones registradas en el estado")
      } catch (err) {
          console.log(err)
          this.warningMessage("", "Algo paso al cargar las regiones :(")
      } finally {
        this.isLoading = false // DISABLE LOADING SCREEN
      }
    },

    async onChangeRegion(value) {
      this.cities = []  // RESET CITIES DATA COLLECTION
      this.selectedCity = null // RESET SELECTED CITY
      this.schools = [] // RESET SCHOOL DATA COLLECTION
      this.selectedSchool = null // RESET SELECTED SCHOOL DATA
      
      if(value == null) return // IF NO ITEM SELECTED DO NOTHING
      
      // POPULATE CITY COLLECTION
      try {
        this.isLoading = true // ENABLE LOADING SCREEN

        const cities = await LocationServices.getCitiesInRegion(value)
        this.cities = cities.map(city => { return { value: city.id, text: city.nombre } }) // MAP ARRAY TO SELECT MODULE
        if(this.cities.length === 0)
          this.warningMessage("", "No hay municipios registrados en la region")
      } catch (err) {
        console.log(err)
        this.warningMessage("", "Algo paso al cargar los municipios :(")
      } finally {
        this.isLoading = false // DISABLE LOADING SCREEN
      }
    },

    async onChangeCity(value) {
      this.schools = [] // RESET SCHOOL DATA COLLECTION
      this.selectedSchool = null // RESET SELECTED SCHOOL DATA

      if(value == null) return // IF NO ITEM SELECTED DO NOTHING

      try {
        this.isLoading = true // ENABLE LOADING SCREEN

        const schools = await SchoolServices.getSchoolsByCity(value)
        this.schools = schools
        if(this.schools.length === 0)
          this.warningMessage("", "No se encontraron escuelas registradas en el municipio")
      } catch (err) {
        console.log(err)
        this.warningMessage("", "Algo paso al cargar las escuelas :(")
      } finally {
        this.isLoading = false // DISABLE LOADING SCREEN
      }
    },

    async chooseSchool(idSchool) {
      this.selectedSchool = null // RESET SELECTED SCHOOL

      if(idSchool == null) return // DO NOTHING IF NULL VALUE

      try {
        this.isLoading = true // ENABLE LOADING SCREEN
        
        const school = await SchoolServices.getSchool(idSchool)
        this.selectedSchool = school

      } catch (err) {
        console.log(err)
        this.warningMessage("", "Algo paso al cargar los datos de la escuela :(")
      } finally {
        this.isLoading = false // DISABLE LOADING SCREEN 
      }
    }
  },

  async beforeMount() {
    // POPULATE STATE COLLECTION
    try {
      this.isLoading = true // ENABLE LOADING SCREEN
      const states = await LocationServices.getStates()
      this.states = states.map((state) => { return { value: state.clave, text: state.nombre, coords: state.coords } })  // MAP ARRAY TO SELECT MODULE
    } catch(err) {
      console.log(err)
      this.warningMessage("", "Algo paso al cargar los estados :(")
    } finally {
      this.isLoading = false // DISABLE LOADING SCREEN
    }
  }
}
</script>

<style lang="stylus">
body
  font-size 14px
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  background-color #fafafa
h1
  font-size 31px
h4
  font-size 18px
h5
  font-size 14px
.map
  height 347px
.pull-right
  text-align right
.empty-data
  color #a2a2a2
</style>